export default __webpack_public_path__ + "static/media/portfolio-smc360-4.2b3b768d.jpg";